module.exports = __webpack_public_path__ + "img/1.1ac369a1.png";